import { useEffect, useState } from "react";
import { Stack, Badge } from "react-bootstrap";
import styles from "./TagBadgesBar.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useParams } from "react-router-dom";
import { api } from "../../../services/Api";

interface ITagBadgesBar {
  isSplitViewEnabled: boolean;
}

const TagBadgesBar: React.FC<ITagBadgesBar> = (props) => {
  const [tags, setTags] = useState<{ name: string }[]>([]);
  const [url] = useState("tags/" + useParams().id);
  const isMobile = useSelector((state: RootState) => state.client.isMobile);

  useEffect(() => {
    api
      .get(`api/${url}`)
      .then((res) => res.data)
      .then((result) => {
        setTags(result);
      });
  }, [url]);

  return (
    <div>
      {tags.length > 0 && (
        <Stack
          className={`pt-2 ${!isMobile || props.isSplitViewEnabled ? styles.containerDesktop : styles.containerMobile}`}
          direction="horizontal"
          gap={1}
        >
          {tags.map((tag: { name: string }, index: number) => (
            <Badge key={`badge-${index}`} bg="light" text="dark">
              #{tag.name}
            </Badge>
          ))}
        </Stack>
      )}
    </div>
  );
};

export default TagBadgesBar;
